import React, { useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers, faUserTag
} from '@fortawesome/free-solid-svg-icons';
import UsersList from '../authorization/components/UsersList';
import UserPermissionsPage from '../authorization/components/UserPermissionsPage';
import RolesList from '../authorization/components/RolesList';
import {
  useUsers,
  useRoles,
  useResourceTypes,
} from '../authorization/hooks/useAuthorizationData';
import '../authorization/Authorization.css';

import {
  SettingLayout,
} from "./SettingShell";

const AuthorizationSettings = () => {
  const [activeTab, setActiveTab] = useState('users');
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedRoleFilter, setSelectedRoleFilter] = useState([]);

  const { data: users, isLoading: usersLoading, refetch: refetchUsers } = useUsers(selectedRoleFilter);
  const { data: roles, isLoading: rolesLoading, refetch: refetchRoles } = useRoles();
  const { data: resourceTypes } = useResourceTypes();

  const handleSelectUser = (user) => {
    setSelectedUser(user);
    setActiveTab('user-permissions');
  };

  const handleBackFromUser = () => {
    setSelectedUser(null);
    setActiveTab('users');
  };

  return (
    <SettingLayout
      title="Authorization & Permissions"
      subtitle="Manage roles, capabilities, and access control for your ESG platform"
      $wide
    >
      <Tab.Container
        activeKey={activeTab}
        onSelect={(k) => {
          if (k !== 'user-permissions') setSelectedUser(null);
          setActiveTab(k);
        }}
      >
        {activeTab !== 'user-permissions' && (
          <Nav variant="tabs" className="auth-main-tabs mb-0">
            <Nav.Item>
              <Nav.Link eventKey="users">
                <FontAwesomeIcon icon={faUsers} className="me-2" />
                Users
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="roles">
                <FontAwesomeIcon icon={faUserTag} className="me-2" />
                Roles
              </Nav.Link>
            </Nav.Item>
          </Nav>
        )}

        <Tab.Content>
          <Tab.Pane eventKey="users">
            {activeTab === 'users' && (
              <UsersList
                users={users}
                isLoading={usersLoading}
                onSelectUser={handleSelectUser}
                roles={roles}
                onRefetch={refetchUsers}
                selectedRoleFilter={selectedRoleFilter}
                onRoleFilterChange={setSelectedRoleFilter}
              />
            )}
          </Tab.Pane>

          <Tab.Pane eventKey="user-permissions">
            {activeTab === 'user-permissions' && selectedUser && (
              <UserPermissionsPage
                user={selectedUser}
                resourceTypes={resourceTypes}
                onBack={handleBackFromUser}
              />
            )}
          </Tab.Pane>

          <Tab.Pane eventKey="roles">
            {activeTab === 'roles' && (
              <RolesList
                roles={roles}
                isLoading={rolesLoading}
                onRefetch={refetchRoles}
              />
            )}
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </SettingLayout>
  );
};

export default AuthorizationSettings;
